import { createFileRoute } from '@tanstack/react-router'
import { InventoryScreen } from '@/features/inventory/routes/inventory-screen'

export const Route = createFileRoute('/inventory')({ component: InventoryScreen })
